import React, { useEffect, useState } from "react";
import "./Header.css";

export default function Header() {
  const slides = [
    {
      image: "/images/ziploc.webp",
      title: "Produits Alimentaires",
      highlight: "de toutes catégories",
      end: "",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/johnson.jpg",
      title: "Proteines",
      highlight: "authentiques des USA",
      end: "au Togo",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/pampers.webp",
      title: "Cerave Lotion, ",
      highlight: "Crémes",
      end: "à portée de main",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/igloo.webp",
      title: "Boissons & snacks",
      highlight: "importés des USA",
      end: "près de chez vous",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/igloo2.webp",
      title: "Boissons & snacks",
      highlight: "importés des USA",
      end: "près de chez vous",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/storage.webp",
      title: "Boissons & snacks",
      highlight: "importés des USA",
      end: "près de chez vous",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/pillow.jpg",
      title: "Boissons & snacks",
      highlight: "importés des USA",
      end: "près de chez vous",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/quaker.webp",
      title: "Boissons & snacks",
      highlight: "importés des USA",
      end: "près de chez vous",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/cinnamon.avif",
      title: "Boissons & snacks",
      highlight: "importés des USA",
      end: "près de chez vous",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
    {
      image: "/images/chair.avif",
      title: "Boissons & snacks",
      highlight: "importés des USA",
      end: "près de chez vous",
      subtitle:
        "Craquez pour une sélection de produits authentiques, friandises et snacks américains disponibles à Casablanca, Dekon et Baguida.",
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentSlide = slides[currentIndex];

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 1000);

    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    if (!isModalOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowRight") nextSlide();
      if (e.key === "ArrowLeft") prevSlide();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isModalOpen, slides.length]);

  return (
    <header className="header-hld">
      <div className="header__container-hld">
        <div className="header__grid-hld">
          {/* LEFT */}
          <div className="header__left-hld">
            <h1 className="header__title-hld">
              Tous vos Produits
              <br />
              <span className="header__titleLine-hld">Américains</span>
              <br />
              en un clic.
            </h1>

            <p className="header__subtitle-hld">
              {currentSlide.subtitle}
              <br />
              Retrouvez-nous à <b>Casablanca</b>, <b>Dekon</b> ou <b>Baguida</b>.
            </p>

            <div className="header__actions-hld">
              <a className="header__btn-hld" href="/products">
                NOS PRODUITS <span className="header__btnArrow-hld">→</span>
              </a>

              <a className="header__tel-hld" href="tel:+22890045926">
                Tel: +228 90 04 59 26
              </a>
            </div>
          </div>

          {/* RIGHT */}
          <div className="header__right-hld">
            <div className="header__carousel-hld">
              <button
                type="button"
                className="header__navBtn-hld header__navBtnPrev-hld"
                onClick={prevSlide}
                aria-label="Image précédente"
              >
                ‹
              </button>

              <button
                className="header__imgBtn-hld"
                type="button"
                onClick={openModal}
                aria-label="Open image"
              >
                <img
                  className="header__heroImg-hld"
                  src={currentSlide.image}
                  alt={currentSlide.highlight}
                  loading="eager"
                />
              </button>

              <button
                type="button"
                className="header__navBtn-hld header__navBtnNext-hld"
                onClick={nextSlide}
                aria-label="Image suivante"
              >
                ›
              </button>

              {/* <div className="header__dots-hld">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    className={`header__dot-hld ${currentIndex === index ? "active" : ""}`}
                    onClick={() => setCurrentIndex(index)}
                    aria-label={`Aller à l'image ${index + 1}`}
                  />
                ))}
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="header__bar-hld">
        <div className="header__barInner-hld">
          Produits américains authentiques • Casablanca • Dekon • Baguida • Tel:
          +228 90 04 59 26
        </div>
      </div>

      {/* MODAL ZOOM */}
      {isModalOpen && (
        <div
          className="header__modalOverlay-hld"
          role="dialog"
          aria-modal="true"
          aria-label="Image preview"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) closeModal();
          }}
        >
          <div className="header__modalContent-hld">
            <button
              type="button"
              className="header__modalClose-hld"
              onClick={closeModal}
              aria-label="Close"
            >
              ✕
            </button>

            <button
              type="button"
              className="header__modalNav-hld header__modalNavPrev-hld"
              onClick={prevSlide}
              aria-label="Image précédente"
            >
              ‹
            </button>

            <img
              className="header__modalImg-hld"
              src={currentSlide.image}
              alt={currentSlide.highlight}
            />

            <button
              type="button"
              className="header__modalNav-hld header__modalNavNext-hld"
              onClick={nextSlide}
              aria-label="Image suivante"
            >
              ›
            </button>
          </div>
        </div>
      )}
    </header>
  );
}